import React, { useState } from 'react';
import moment from "moment";
import Datetime from 'react-datetime';
import "moment/locale/en-gb";
import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import { saveAs } from 'file-saver';
import "react-datetime/css/react-datetime.css";
import QRCode from 'qrcode';

moment.updateLocale("en-gb", {
    week: {
        dow: 1,
    },
});

const UpdateContact = (props) => {

    const { updateContract, tab, isNewContract, openModal, setNewContractAdded } = props;
    const [contract, setContract] = useState(updateContract);
    const [disableSaveButton, setDisableSaveButton] = useState(false);

    const getConstructionYear = (value) => {
        if (!value) return "";

        const parsedDate = moment(value, ["DD.MM.YYYY", moment.ISO_8601], true);

        if (!parsedDate.isValid()) {
            return value;
        }

        return parsedDate.format("YYYY");
    };

    const handleClickedUpdateContract = async () => {
        const { length, ship_name, serial_number } = contract;

        const fileName = simplifyKey(`DOC ${tab.name} No. ${serial_number} ${length.replace(/\//g, '')} ${ship_name} ${dateOfCostruction}.pdf`);

        await modifyPdf({
            ...contract,
            ship_name: ship_name,
            file_name: simplifyKey(fileName),
            expiry_date: expiryDate,
            year_of_construction: yearOfConstruction,
            date: dateOfCostruction
        }, tab);
    };

    async function modifyPdf(contract, tab) {
        setDisableSaveButton(true);

        const {
            serial_number,
            length,
            ship_name,
            company_name,
            date,
            file_name,
            expiry_date,
            year_of_construction,
            extension_rope
        } = contract;

        const constructionYear = getConstructionYear(year_of_construction);

        const url = `${process.env.REACT_APP_BACKEND_UPLOAD_LOCATION}/empty/${tab.type}.pdf`;
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        pdfDoc.registerFontkit(fontkit);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        const { width, height } = firstPage.getSize();

        const fontUrl = process.env.PUBLIC_URL + '/fonts/DejaVuSans-Bold.ttf';
        const dejavuSansBoldBuffer = await fetch(fontUrl).then(res => res.arrayBuffer());

        if (!dejavuSansBoldBuffer) {
            console.error("Failed to load DejaVuSans-Bold font buffer");
            return;
        }

        const dejavuSansBold = await pdfDoc.embedFont(dejavuSansBoldBuffer);

        switch (tab.type) {
            case 'pilot_ladder_contracts':
                firstPage.drawText(`${serial_number}`, {
                    x: 260,
                    y: 315,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                firstPage.drawText(`${constructionYear}`, {
                    x: 260,
                    y: 299,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                firstPage.drawText(`${expiry_date}`, {
                    x: 260,
                    y: 283,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                if (ship_name) {
                    firstPage.drawText(`${ship_name}`, {
                        x: 260,
                        y: 267,
                        size: 12,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }

                firstPage.drawText(`${length.endsWith('MT') ? length : length + ' MT'}`, {
                    x: 260,
                    y: 219,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                if (extension_rope) {
                    firstPage.drawText(`${extension_rope}`, {
                        x: 360,
                        y: 219,
                        size: 12,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }

                firstPage.drawText(`${date}`, {
                    x: 260,
                    y: 183,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                break;

            case 'embed_ladder_contracts':
                firstPage.drawText(`${serial_number}`, {
                    x: 260,
                    y: 323,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                firstPage.drawText(`${constructionYear}`, {
                    x: 260,
                    y: 307,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                firstPage.drawText(`${expiry_date}`, {
                    x: 260,
                    y: 291,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                if (ship_name) {
                    firstPage.drawText(`${ship_name}`, {
                        x: 260,
                        y: 275,
                        size: 12,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }

                firstPage.drawText(`${length.endsWith('MT') ? length : length + ' MT'}`, {
                    x: 260,
                    y: 227,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                if (extension_rope) {
                    firstPage.drawText(`${extension_rope}`, {
                        x: 360,
                        y: 227,
                        size: 12,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }

                firstPage.drawText(`${date}`, {
                    x: 260,
                    y: 191,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                break;

            default:
                console.error("Unknown contract type");
                return;
        }

        const qrUrl = await createPresignedUrl(file_name);
        const qrCodeDataUrl = await QRCode.toDataURL(qrUrl);
        const qrImage = await pdfDoc.embedPng(qrCodeDataUrl);
        const qrWidth = 100;
        const qrHeight = 100;

        firstPage.drawImage(qrImage, {
            x: width - qrWidth - 30,
            y: height - qrHeight - 30,
            width: qrWidth,
            height: qrHeight,
        });

        const pdfBytes = await pdfDoc.save();

        const formData = new FormData();
        formData.append("file", new Blob([pdfBytes], { type: "application/pdf" }), file_name);
        formData.append("fileName", file_name);
        formData.append("contractData", JSON.stringify({
            id: isNewContract ? null : contract.id,
            length,
            ship_name,
            company_name,
            expiry_date,
            date,
            file_name,
            url: qrUrl,
            serial_number,
            year_of_construction,
            extension_rope,
            contract_type: tab.type,
        }));

        const updateUrl = isNewContract
            ? `${process.env.REACT_APP_BACKEND_URL}/createContract`
            : `${process.env.REACT_APP_BACKEND_URL}/updateContract`;

        const response = await fetch(updateUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Failed to upload PDF');
        }

        saveAs(new Blob([pdfBytes]), file_name);
        openModal(false);
        setDisableSaveButton(false);
        setNewContractAdded(true);
    }

    function simplifyKey(filename) {
        const charMap = {
            'ı': 'i',
            'İ': 'I',
            'ö': 'o',
            'Ö': 'O',
            'ü': 'u',
            'Ü': 'U',
            'ş': 's',
            'Ş': 'S',
            'ç': 'c',
            'Ç': 'C',
            'ğ': 'g',
            'Ğ': 'G',
            ' ': '_',
        };

        const cleanedFilename = filename
            .split('')
            .map(char => charMap[char] || char)
            .join('')
            .replace(/[^a-zA-Z0-9._-]/g, '_');

        return cleanedFilename;
    }

    function createPresignedUrl(fileName) {
        return `${process.env.REACT_APP_BACKEND_URL}/certifications/pdf/${fileName}`;
    }

    const getInitialExpiryDate = () => {
        if (!isNewContract && updateContract && updateContract.expiry_date) {
            const parsed = moment(updateContract.expiry_date, ["DD-MM-YYYY", "DD.MM.YYYY", moment.ISO_8601]);
            if (parsed.isValid()) {
                return parsed.format("DD-MM-YYYY");
            }
            return updateContract.expiry_date;
        }
        return moment().add(1, "days").add(30, "months").format("DD-MM-YYYY");
    };

    const getInitialYearOfConstruction = () => {
        if (!isNewContract && updateContract && updateContract.year_of_construction) {
            const parsed = moment(updateContract.year_of_construction, ["YYYY", "DD-MM-YYYY", "DD.MM.YYYY", moment.ISO_8601]);
            if (parsed.isValid()) {
                return parsed.format("YYYY");
            }
            return updateContract.year_of_construction;
        }
        return moment().add(1, "days").format("YYYY");
    };

    const [dateOfCostruction, setDateOfCostruction] = useState(moment().add(1, "days").format("DD-MM-YYYY"));
    const [expiryDate, setExpiryDate] = useState(getInitialExpiryDate());
    const [yearOfConstruction, setYearOfCostruction] = useState(getInitialYearOfConstruction());
    return (
        <div className='absolute top-0 right-0 flex flex-col w-[100%] overflow-hidden h-[100vh] backdrop-blur-md flex justify-center items-center'>
            <div className='w-full md:w-[30%] text-right'>
                <button
                    onClick={() => openModal(false)}
                    type="button"
                    className="m-2 rounded bg-red-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                >
                    <svg className='w-6 h-6' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6M6 6l12 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>

            <div className='w-full p-3 bg-white items-center justify-center md:w-[30%] rounded-md border-2'>
                <div className='m-2'>
                    <label htmlFor="serial_number" className="block text-sm font-medium leading-6 text-gray-900">
                        Serial Number
                    </label>
                    <input
                        id="serial_number"
                        name="text"
                        type="text"
                        disabled={!isNewContract}
                        placeholder={"2025-"}
                        onChange={(e) => setContract({ ...contract, serial_number: e.target.value })}
                        value={contract.serial_number}
                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="length" className="block text-sm font-medium leading-6 text-gray-900">
                        Length
                    </label>
                    <input
                        id="length"
                        name="text"
                        type="text"
                        value={contract.length}
                        onChange={(e) => setContract({ ...contract, length: e.target.value })}
                        placeholder="e.g. 7 / 8 / 9 (MT will be added automatically)"
                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="ship_name" className="block text-sm font-medium leading-6 text-gray-900">
                        Ship Name
                    </label>
                    <input
                        id="ship_name"
                        name="text"
                        type="text"
                        value={contract.ship_name}
                        onChange={(e) => setContract({ ...contract, ship_name: e.target.value })}
                        placeholder=""
                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="company_name" className="block text-sm font-medium leading-6 text-gray-900">
                        Company Name / Firma Adı
                    </label>
                    <input
                        id="company_name"
                        name="text"
                        type="text"
                        value={contract.company_name}
                        onChange={(e) => setContract({ ...contract, company_name: e.target.value })}
                        placeholder=""
                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="expiry_date" className="block text-sm font-medium leading-6 text-gray-900">
                        Expiry Date
                    </label>
                    <Datetime
                        value={expiryDate}
                        onChange={(date) => {
                            const momentDate = moment(date);
                            if (momentDate.isValid()) {
                                setExpiryDate(momentDate.format("DD-MM-YYYY"));
                            }
                        }}
                        locale="en-gb"
                        timeFormat={false}
                        dateFormat={"DD-MM-YYYY"}
                        className="border block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="year_of_construction" className="block text-sm font-medium leading-6 text-gray-900">
                        Date of Construction
                    </label>
                    <Datetime
                        value={dateOfCostruction}
                        onChange={(date) => {
                            const momentDate = moment(date);
                            if (momentDate.isValid()) {
                                const formattedDate = momentDate.format("DD-MM-YYYY");
                                setDateOfCostruction(formattedDate);
                                setExpiryDate(momentDate.clone().add(30, "months").format("DD-MM-YYYY"));
                                setYearOfCostruction(momentDate.format("YYYY"));
                            }
                        }}
                        locale="en-gb"
                        timeFormat={false}
                        dateFormat={"DD-MM-YYYY"}
                        className="border block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="year_of_construction" className="block text-sm font-medium leading-6 text-gray-900">
                        Year of Construction
                    </label>
                    <Datetime
                        value={yearOfConstruction}
                        onChange={(date) => {
                            const momentDate = moment(date);
                            if (momentDate.isValid()) {
                                setYearOfCostruction(momentDate.format("YYYY"));
                            }
                        }}
                        locale="en-gb"
                        timeFormat={false}
                        dateFormat={"YYYY"}
                        className="border block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="extension_rope" className="block text-sm font-medium leading-6 text-gray-900">
                        Extension Rope
                    </label>
                    <input
                        id="extension_rope"
                        name="text"
                        type="text"
                        value={contract.extension_rope || ''}
                        onChange={(e) => setContract({ ...contract, extension_rope: e.target.value })}
                        placeholder="Extension Rope"
                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>

                <div className='m-2'>
                    <label htmlFor="contract_type" className="block text-sm font-medium leading-6 text-gray-900">
                        Contract Type
                    </label>
                    <input
                        id="contract_type"
                        name="text"
                        type="text"
                        value={tab.name}
                        disabled={true}
                        placeholder=""
                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>

                <button
                    onClick={handleClickedUpdateContract}
                    type="button"
                    disabled={disableSaveButton}
                    className="m-2 rounded bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    Update Contract
                </button>
            </div>
        </div>
    );
};

export default UpdateContact;